function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { createSlice } from '@reduxjs/toolkit';
import { rolesResource, routesResource } from '../../resources/Roles.resource';
var initialState = {
    roles: [],
    routes: []
};
export var RolesAccessReducer = createSlice({
    name: 'rolesAccess',
    initialState: initialState,
    reducers: {
        setRoles: function setRoles(state, payloadAction) {
            state.roles = payloadAction.payload.map(function (item) {
                return rolesResource(item);
            });
        },
        setRoutes: function setRoutes(state, payloadAction) {
            state.routes = payloadAction.payload.map(function (item) {
                return routesResource(item);
            });
        },
        updateRoute: function updateRoute(state, payloadAction) {
            state.routes = payloadAction.payload.map(function (item) {
                return routesResource(item);
            });
        },
        deleteRoute: function deleteRoute(state, payloadAction) {
            var deleteRoutes = JSON.parse(payloadAction.payload);
            state.routes = state.routes.map(function (item) {
                return deleteRoutes.includes(item.name) ? _objectSpread(_objectSpread({}, item), {}, {
                    available: false
                }) : item;
            });
        }
    }
});
var _RolesAccessReducer$a = RolesAccessReducer.actions, setRoles = _RolesAccessReducer$a.setRoles, setRoutes = _RolesAccessReducer$a.setRoutes, updateRoute = _RolesAccessReducer$a.updateRoute, deleteRoute = _RolesAccessReducer$a.deleteRoute;
export { setRoles, setRoutes, updateRoute, deleteRoute };
export default RolesAccessReducer.reducer;
